import ResidentAssessmentTemplate from "app/features/residents/templates/view/ResidentAssessmentTemplate";

export default function AssessmentScreen() {
  return <ResidentAssessmentTemplate />;
}
